import { getTranslateNsT } from "@/utils/getTranslateNsT";
const t = getTranslateNsT("topup");

export async function validateRule(
  rules: { r: boolean; message: string }[],
  callback: any
) {
  const matchErrorRule = rules.find((item) => item.r);
  matchErrorRule && callback(new Error(matchErrorRule.message));
}

export function useValidator() {
  const nameValidator = (args: any, allowEmpty?: boolean) => {
    const [, value, callback] = args;
    if (allowEmpty && !value) return callback();
    const rules = [
      {
        r: value === "" || !value,
        message: t("topup_lottery_recipient_placeholder"),
      },
    ];
    validateRule(rules, callback);
    callback();
  };

  const phoneValidator = (args: any, allowEmpty?: boolean) => {
    const [, value, callback] = args;
    if (allowEmpty && !value) return callback();
    const rules = [
      {
        r: value === "" || !value,
        message: t("topup_lottery_information_placeholder"),
      },
      {
        r: !/^1\d{10}$|(\(\d*\))(.+)/.test(value),
        message: t("lottery_phone_error"),
      },
    ];
    validateRule(rules, callback);
    callback();
  };
  const addressValidator = (args: any, allowEmpty?: boolean) => {
    const [, value, callback] = args;
    if (allowEmpty && !value) return callback();
    const rules = [
      {
        r: value === "" || !value,
        message: t("topup_lottery_address_placeholder"),
      },
    ];
    validateRule(rules, callback);
    callback();
  };
  return {
    nameValidator,
    addressValidator,
    phoneValidator,
  };
}
